import {
  addDays,
  addMinutes,
  setHours,
  setMinutes,
  startOfHour,
} from 'date-fns';
import { create } from 'zustand';

import type { Car } from '@/api/cars/types';
import type { Filter } from '@/api/cars/use-car-filters';
// import { persist } from 'zustand/middleware';
import type { Address } from '@/api/subscriptions/types';

interface SearchState {
  deliveryModeEnabled: boolean;
  viewMode: 'map' | 'list';
  address: Address | null;
  startDatetime: Date | null;
  endDatetime: Date | null;
  deliveryDeliverToAddress: Address | null;
  deliveryReturnAddress: Address | null;
  locationId: number | undefined;
  page: number;
  cars: Car[];
  car: Car | null;
  filters: Filter[];
  code: string | null;
  promo: string | null;
  hidePromoPopup: boolean;
  setCode: (code: string) => void;
  setPromo: (promo: string) => void;
  setHidePromoPopup: (hidePromoPopup: boolean) => void;
  setDeliveryModeEnabled: (deliveryModeEnabled: boolean) => void;
  setViewMode: (viewMode: 'map' | 'list') => void;
  setAddress: (address: any) => void;
  setStartDatetime: (startDatetime: Date) => void;
  setEndDatetime: (endDatetime: Date) => void;
  setDeliveryDeliverToAddress: (deliveryDeliverToAddress: any) => void;
  setDeliveryReturnToAddress: (deliveryReturnAddress: any) => void;
  setLocationId: (locationId: number) => void;
  setPage: (page: number) => void;
  setCars: (cars: Car[]) => void;
  setCar: (car: Car) => void;
  setFilters: (filters: Filter[]) => void;
  reset: () => void;
}

const startDatetime = startOfHour(addMinutes(addDays(new Date(), 3), 60));
const endDatetime = setMinutes(setHours(addDays(startDatetime, 3), 10), 0);

const useSearchStore = create<SearchState>((set) => ({
  deliveryModeEnabled: false,
  viewMode: 'map',
  address: null,
  startDatetime: startDatetime,
  endDatetime: endDatetime,
  deliveryDeliverToAddress: null,
  deliveryReturnAddress: null,
  locationId: undefined,
  page: 1,
  cars: [],
  car: null,
  filters: [],
  code: null,
  promo: null,
  hidePromoPopup: false,
  setCode: (code: string) => {
    set((state) => ({
      ...state,
      code,
    }));
  },
  setPromo: (promo: string) => {
    set((state) => ({
      ...state,
      promo,
    }));
  },
  setHidePromoPopup: (hidePromoPopup: boolean) => {
    set((state) => ({
      ...state,
      hidePromoPopup,
    }));
  },
  setDeliveryModeEnabled: (deliveryModeEnabled: boolean) => {
    set((state) => ({
      ...state,
      deliveryModeEnabled,
    }));
  },
  setViewMode: (viewMode: 'map' | 'list') => {
    set((state) => ({
      ...state,
      viewMode,
    }));
  },
  setAddress: (address: any) => {
    set((state) => ({
      ...state,
      address,
    }));
  },
  setStartDatetime: (startDatetime: Date) => {
    set((state) => ({
      ...state,
      startDatetime,
    }));
  },
  setEndDatetime: (endDatetime: Date) => {
    set((state) => ({
      ...state,
      endDatetime,
    }));
  },
  setDeliveryDeliverToAddress: (deliveryDeliverToAddress: any) => {
    set((state) => ({
      ...state,
      deliveryDeliverToAddress,
    }));
  },
  setDeliveryReturnToAddress: (deliveryReturnAddress: any) => {
    set((state) => ({
      ...state,
      deliveryReturnAddress,
    }));
  },
  setLocationId: (locationId: number | undefined) => {
    set((state) => ({
      ...state,
      locationId,
    }));
  },
  setPage: (page: number) => {
    set((state) => ({
      ...state,
      page,
    }));
  },
  setCars: (cars: Car[]) => {
    set((state) => ({
      ...state,
      cars,
    }));
  },
  setCar: (car: Car) => {
    set((state) => ({
      ...state,
      car,
    }));
  },
  setFilters: (filters: Filter[]) => {
    set((state) => ({
      ...state,
      filters,
    }));
  },
  reset: () => {
    set({
      deliveryModeEnabled: false,
      viewMode: 'list',
      address: null,
      startDatetime: startDatetime,
      endDatetime: endDatetime,
      deliveryDeliverToAddress: null,
      deliveryReturnAddress: null,
      locationId: undefined,
      page: 1,
      cars: [],
      car: null,
      filters: [],
      code: null,
      promo: null,
      hidePromoPopup: false,
    });
  },
}));

export default useSearchStore;
